import React from "react";
import HelpdeskCenter from "../../components/helpdesk/HelpdeskCenter";

const Helpdesk = () => {
  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <HelpdeskCenter />
    </div>
  );
};

export default Helpdesk;

